export default {
  title: 'common.news',
  ogTitle: 'common.news'
}
